//dwain added after install livewire statamic
//import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

//import '@fontsource-variable/inter';
// js-cookie werd alleen door de oude chatpopup gebruikt.

// import { Clip } from '@maveio/components'; WEG GEHAALD OP DISCORD ADVIES
//window.customElements.define('mave-player', Player);

import Alpine from "alpinejs";
import { t } from "./renoco/taal";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
//import morph from "@alpinejs/morph";
import persist from "@alpinejs/persist";
import precognition from "laravel-precognition-alpine";
import forms from './forms.js'
import { createData as createShopifyData, createStore as createShopifyStore } from './vendor/shopify/alpine';
import maakBoeking from './renoco/boeking.js';
import maakOpeningstijden, { leesRenocoData } from './renoco/openingstijden.js';
import maakInBeeld from './renoco/inBeeld.js';
import maakAnnotaties from './renoco/annotaties.js';
import maakActieConfetti, { vierFeest } from './renoco/confetti.js';
import { laadMave } from './renoco/mave.js';

// Flatpickr (datumkiezer van het oude afspraakformulier) laadt alleen als dat veld
// echt op de pagina staat, zodat hij niet op elke pagina meekomt.
let flatpickrBelofte = null;
const laadFlatpickr = () => {
    flatpickrBelofte ??= Promise.all([
        import('flatpickr'),
        import('flatpickr/dist/l10n/nl.js'),
        import('flatpickr/dist/flatpickr.css'),
    ]).then(([{ default: flatpickr }, { Dutch }]) => {
        flatpickr.localize(Dutch);
        return { flatpickr, Dutch };
    });

    return flatpickrBelofte;
};

//Javascript
//Global callback for Google Maps API loading
function handleMapsApiLoaded() {
    if (window.alpineShowroomMapInstance && typeof window.alpineShowroomMapInstance.createMap === 'function') {
      // console.log('Google Maps API loaded via callback. Calling createMap.'); // Voor debugging
      window.alpineShowroomMapInstance.createMap();
      // Clean up the global reference if desired
      // delete window.alpineShowroomMapInstance;
    } else {
      // console.warn('handleMapsApiLoaded called, but window.alpineShowroomMapInstance is not available or createMap is not a function.');
    }
  }
  
// Ensure the function is globally accessible, especially if using modules
window.handleMapsApiLoaded = handleMapsApiLoaded;
  
// Call Alpine.
window.Alpine = Alpine;

Alpine.data('forms', forms);

Alpine.plugin([collapse, focus, persist, precognition]);
createShopifyStore(Alpine);
createShopifyData(Alpine);

// Renoco: één bron voor openingstijden en de showroomafspraak.
const renocoData = leesRenocoData();
Alpine.store('boeking', maakBoeking());
Alpine.store('openingstijden', maakOpeningstijden(renocoData));

// Plakkende kop: rustige lijn zodra er gescrold wordt.
Alpine.data('kop', () => ({
    gescrold: false,
    menuOpen: false,
    init() {
        const meet = () => { this.gescrold = window.scrollY > 8; };
        meet();
        window.addEventListener('scroll', meet, { passive: true });
    },
    openMenu() {
        this.menuOpen = true;
        document.documentElement.classList.add('overflow-hidden');
    },
    sluitMenu() {
        this.menuOpen = false;
        document.documentElement.classList.remove('overflow-hidden');
    },
}));

document.addEventListener('alpine:init', () => {
    Alpine.data('appointmentField', (options) => ({
        fieldName: options.fieldName,
        businessHours: options.businessHours,
        selectedDate: '',
        selectedTime: '',
        availableTimes: [],
        fieldError: '',
        
        async initFlatpickr() {
            try {
                const { flatpickr, Dutch } = await laadFlatpickr();
                const today = new Date();
                
                // Bereken beschikbare dagen op basis van businessHours
                const enabledDays = this.businessHours
                    .filter(day => day.open)
                    .map(day => day.weekday.value.toLowerCase());

                const instance = flatpickr(this.$refs.datePicker, {
                    locale: Dutch,
                    dateFormat: "Y-m-d",
                    minDate: "today",
                    disable: [
                        function(date) {
                            // Maak van zondag 0, maandag 1, etc. naar de dagen in de businessHours
                            const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                            const dayName = dayNames[date.getDay()];
                            return !enabledDays.includes(dayName);
                        }
                    ],
                    onChange: (selectedDates, dateStr) => {
                        this.selectedDate = dateStr;
                        if (dateStr) {
                            this.generateAvailableTimes(dateStr);
                        } else {
                            this.availableTimes = [];
                            this.selectedTime = '';
                        }
                    }
                });
                
                // Bewaar instance voor eventuele cleanup later
                this.flatpickrInstance = instance;
            } catch (error) {
                console.error('Flatpickr initialisatie fout:', error);
                this.fieldError = t('Er is een probleem opgetreden bij het laden van de datumkiezer.');
            }
        },
        
        generateAvailableTimes(dateStr) {
            try {
                const date = new Date(dateStr);
                const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                const dayName = dayNames[date.getDay()];
                
                // Vind de business hours voor deze dag
                const daySettings = this.businessHours.find(day => day.weekday.value.toLowerCase() === dayName);
                
                if (!daySettings || !daySettings.open) {
                    this.availableTimes = [];
                    return;
                }
                
                // Genereer tijdsloten van 30 minuten tussen start en eind tijd
                const startTime = daySettings.start_time;
                const endTime = daySettings.end_time;
                
                const times = [];
                let current = this.parseTime(startTime);
                const end = this.parseTime(endTime);
                
                while (current < end) {
                    times.push(this.formatTime(current));
                    current.setMinutes(current.getMinutes() + 30);
                }
                
                this.availableTimes = times;
                
                // Reset de geselecteerde tijd wanneer de datum verandert
                this.selectedTime = '';
            } catch (error) {
                console.error('Fout bij genereren van beschikbare tijden:', error);
                this.fieldError = t('Er is een probleem opgetreden bij het laden van de beschikbare tijden.');
            }
        },
        
        parseTime(timeStr) {
            const [hours, minutes] = timeStr.split(':').map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);
            return date;
        },
        
        formatTime(date) {
            return date.toTimeString().substr(0, 5);
        }
    }));
});

Alpine.data("GTMEvent", () => ({
    init() {},
    fireGTM(ev) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "custom_click",
            eventCategory: "Click",
            eventAction: ev,
            eventLabel: window.location.href,
        });
    },
}));
Alpine.data("formHandler", () => ({
    success: false,
    submitted: false,
    form: null,
    init() {
        this.form = this.$form(
            "post",
            this.$refs.form.getAttribute("action"),
            JSON.parse(this.$refs.form.getAttribute("x-data")).form,
            {
                headers: {
                    "X-CSRF-Token": {
                        toString: () =>
                            this.$refs.form.querySelector('[name="_token"]')
                                .value,
                    },
                },
            }
        );
    },
    successHook(response) {
        {
            {
                success_hook;
            }
        }

        setTimeout(() => {
            this.success = false;
        }, 4500);
    },
    submit() {
        this.submitted = true;
        this.form
            .submit()
            .then((response) => {
                this.form.reset();
                this.$refs.form.reset();
                this.success = true;
                this.submitted = false;
                this.successHook(response);
            })
            .then(this.$refs.form.scrollIntoView())
            .catch((error) => {
                const summary = document.querySelector("#summary");
                if (summary) {
                    this.$focus.focus(summary.querySelector("a"));
                } else {
                    console.log(error);
                }
            });
    },
}));
Alpine.data("stepsHandler", () => ({
    step: 1,
    selectedProductSlug: null,
    selectedStorings: [], // Array voor meerdere storingen
    form: {
        product: null,
        storings: null,
        // andere form velden hier
    },

    init() {
        const urlParams = new URLSearchParams(window.location.search);
        const productSlug = urlParams.get("product");
        //const storingSlug = urlParams.get('storing');
        const storingsSlug = urlParams.get("storings")
            ? urlParams.get("storings").split(",")
            : [];

        if (productSlug) {
            this.selectedProductSlug = productSlug;
            setTimeout(() => {
                this.setProductField(productSlug); // Vul het productveld in met de slug
            }, 1000); // 1000 milliseconden vertraging
            this.step = 2;

            if (storingsSlug.length > 0) {
                this.selectedStorings = storingsSlug;
                setTimeout(() => {
                    this.setStoringField(); 
                }, 1000); // 1000 milliseconden vertraging
                this.step = 2;
            }
        }
    },

    selectProduct(slug) {
        this.selectedProductSlug = slug;
        this.setProductField(slug); // Vul het productveld in met de slug
        this.updateUrl();
        this.nextStep();
    },

    //   setProductField(slug) {
    //       const productInput = document.getElementById('product');
    //       if (productInput) {
    //           productInput.value = slug; // Stel de waarde van het input veld in
    //           this.form.product = slug;  // Zorg ervoor dat het form object wordt bijgewerkt
    //       }
    //   },
    setProductField(slug) {
        this.form.product = slug;
        const productInput = document.getElementById("product");
        if (productInput) {
            productInput.value = slug;
            productInput.dispatchEvent(new Event("input")); // Trigger input event
        }
    },

    toggleStoring(slug) {
        const index = this.selectedStorings.indexOf(slug);
        if (index === -1) {
            this.selectedStorings.push(slug); // Voeg toe als het niet bestaat
        } else {
            this.selectedStorings.splice(index, 1); // Verwijder als het al geselecteerd is
        }
        this.setStoringField(); // Update de input met de huidige selectie
        this.updateUrl();
    },

    updateUrl() {
        let url = new URL(window.location.href);
        url.searchParams.set("product", this.selectedProductSlug);

        if (this.selectedStorings.length > 0) {
            url.searchParams.set("storings", this.selectedStorings.join(","));
        } else {
            url.searchParams.delete("storings");
        }

        window.history.pushState({}, "", url);
    },

    setStoringField() {
        const storingInput = document.getElementById("storing"); // Zorg ervoor dat dit het juiste ID is
        if (storingInput) {
            const storingsWithSpacesAndCapitals = this.selectedStorings.map(slug => 
                slug.replace(/-/g, " ") // Vervang alle '-' door spaties
                    .replace(/\b\w/g, char => char.toUpperCase()) // Zet eerste letter van elk woord in hoofdletter
            );
            storingInput.value = storingsWithSpacesAndCapitals.join(", "); // Vul de input met een komma-gescheiden lijst
            storingInput.dispatchEvent(new Event("input")); // Trigger input event
        }
    },

    selectStoring(slug) {
        this.selectedStoringSlug = slug;
        this.setStoringField(slug); // Vul het storing veld in met de slug
        this.updateUrl();
        this.nextStep();
    },

    nextStep() {
        if (this.step === 1) {
            this.step++;
        } else {
            if (this.step === 2 && this.selectedStorings.length > 0) {
                this.step = 3;
            }
        }
    },

    previousStep() {
        if (this.step > 1) {
            this.step--;
            this.updateUrl();
        }
    },

    goToStep(step) {
        if (
            step <= this.step ||
            (step === 3 && this.selectedStorings.length > 0)
        ) {
            this.step = step;
            this.updateUrl();
        }
    },
}));

// if (window.livewireScriptConfig?.csrf === 'STATAMIC_CSRF_TOKEN') {
//   document.addEventListener('statamic:nocache.replaced', () => Livewire.start());
// } else {
//   Livewire.start();
// }

// Video laadt pas bij een tik op "Bekijk de video".
window.laadMave = laadMave;
window.renocoConfetti = vierFeest;

// Een afspraaklink (?afspraak=1) opent het afspraakvenster zodra de pagina klaarstaat.
document.addEventListener('alpine:initialized', () => Alpine.store('boeking').openenVanuitLink());

Alpine.start();

// Getekende beweging: tekeningen en stapels komen één keer tot leven zodra ze in beeld zijn.
maakInBeeld();

// Annotaties: callouts naast de foto, zonder overlap.
maakAnnotaties();
maakActieConfetti();
